/**
 * @license Copyright © HatioLab Inc. All rights reserved.
 */

/* Inspired by https://github.com/john-doherty/long-press-event */

var timer = null as any

// check if we're using a touch screen
//@ts-ignore
const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0

// switch to touch events if using a touch screen
const mouseDown = isTouch ? 'touchstart' : 'mousedown'
const mouseOut = isTouch ? 'touchcancel' : 'mouseout'
const mouseUp = isTouch ? 'touchend' : 'mouseup'
const mouseMove = isTouch ? 'touchmove' : 'mousemove'

/*
 * Fires the 'long-press' event on element
 * @returns {void}
 */
function fireLongPressEvent(this: HTMLElement) {
  clearLongPressTimer()

  // fire the long-press event
  var suppressClickEvent = this.dispatchEvent(new CustomEvent('long-press', { bubbles: true, cancelable: true }))

  if (suppressClickEvent) {
    // temporarily intercept and clear the next click
    this.addEventListener(
      mouseUp,
      function clearMouseUp(e) {
        this.removeEventListener(mouseUp, clearMouseUp, true)
        cancelEvent(e)
      },
      true
    )
  }
}

/*
 * method responsible for starting the long press timer
 * @param {event} e - event object
 * @returns {void}
 */
function startLongPressTimer(e: Event) {
  clearLongPressTimer(e)

  var el = e.target as HTMLElement

  // get delay from html attribute if it exists, otherwise default to 1500
  var longPressDelayInMs = parseInt(el.getAttribute('data-long-press-delay') || '600', 10)

  // start the timer
  timer = setTimeout(fireLongPressEvent.bind(el), longPressDelayInMs)
}

/*
 * method responsible for clearing a pending long press timer
 * @param {event} e - event object
 * @returns {void}
 */
function clearLongPressTimer(e?: Event) {
  clearTimeout(timer)
  timer = null
}

/*
 * Cancels the current event
 * @param {object} e - browser event object
 * @returns {void}
 */
function cancelEvent(e: Event) {
  e.stopImmediatePropagation()
  e.preventDefault()
  e.stopPropagation()
}

/**
 * method set target element to be able to respond longpress event
 * @param {HTMLElement} element target element
 */
export const longpressable = (element: HTMLElement) => {
  // hook events that clear a pending long press event
  element.addEventListener(mouseOut, clearLongPressTimer, true)
  element.addEventListener(mouseUp, clearLongPressTimer, true)
  element.addEventListener(mouseMove, clearLongPressTimer, true)
  element.addEventListener('wheel', clearLongPressTimer, true)
  element.addEventListener('scroll', clearLongPressTimer, true)

  // hook events that can trigger a long press event
  element.addEventListener(mouseDown, startLongPressTimer, true) // <- start

  // cancel context for touch display
  if (mouseDown.indexOf('touch') === 0) {
    element.addEventListener('contextmenu', cancelEvent, true)
  } else {
    element.addEventListener('contextmenu', clearLongPressTimer, true)
  }
}
